/* lua.js generated code 0.3.0 */

require("clover/config/LocalDataConfig")
require("clover/data/UserManager")
Persistence = {}
var fullPathOfLocalData = he.HeResPathUtils.getUserDataPath() + 'Presistence'
var kLocalDataExt = ".ds"
Persistence.writeFileData = function (data, fileName) {
    if (table.indexof(LocalUserDataFiles, fileName)) {
        Persistence.writeUserDataToStorage(data, fileName)
    } else {
        Persistence.writeToStorage(data, fileName)
    }
}
Persistence.readFileData = function (fileName) {
    if (table.indexof(LocalUserDataFiles, fileName)) {
        // WARN: maybe multi result
        return Persistence.readUserDataFromStorage(fileName)
    } else {
        // WARN: maybe multi result
        return Persistence.readFromStorage(fileName)
    }
}
Persistence.transferUserData = function (oldUid, newUid) {
    for (var k in NeedTransferFiles) {
        var v = NeedTransferFiles[k]
        var oldSrcData = Persistence.readFromStorage(tostring(oldUid) + "/" + k)
        var newSrcData = Persistence.readFromStorage(tostring(newUid) + "/" + k)
        var destData = _G[v].transfer(oldSrcData, newSrcData)
        Persistence.writeToStorage(destData, tostring(newUid) + "/" + k)
    }
}
Persistence.writeUserDataToStorage = function (data, fileName) {
    var uid = UserManager.getInstance().uid
    // he.HeFileUtils.mkdirIfNotExists(fullPathOfLocalData + "/" + tostring(uid))
    Persistence.writeToStorage(data, tostring(uid) + "/" + fileName)
}
Persistence.writeToStorage = function (data, fileName) {
    // if __DEBUG then
    //     self:writeToStorageDebug(data, fileName)
    // else
    Persistence.writeToStorageRelease(data, fileName)
}
Persistence.writeToStorageRelease = function (data, fileName) {
    if (data && fileName) {
        var filePath = fullPathOfLocalData + "/" + fileName
        // var pathArr = string.split(filePath, "/")
        // table.remove(pathArr, $len(pathArr))
        // var dirPath = table.concat(pathArr, "/")
        // if (__IOS || __ANDROID) {
        //     dirPath = "/" + dirPath
        // }
        // he.HeFileUtils.mkdirIfNotExists(dirPath)
        // var am3data = amf3.encode(data)
        let str
        if (type(data) === "string" || type(data) === "number") {
            str = data
        }else {
            str = JSON.stringify($tableToObj(data))
        }
        Persistence.safeWriteStringToFile(str, filePath)
    }
}
Persistence.writeToStorageDebug = function (data, fileName) {
    if (data && fileName) {
        var filePath = fullPathOfLocalData + "/" + fileName
        // var pathArr = string.split(filePath, "/")
        // table.remove(pathArr, $len(pathArr))
        // var dirPath = table.concat(pathArr, "/")
        // if (__IOS || __ANDROID) {
        //     dirPath = "/" + dirPath
        // }
        // he.HeFileUtils.mkdirIfNotExists(dirPath)
        Persistence.safeWriteStringToFile(JSON.stringify($tableToObj(data)), filePath)
    }
}
Persistence.readUserDataFromStorage = function (fileName) {
    var uid = UserManager.getInstance().uid
    // WARN: maybe multi result
    return Persistence.readFromStorage(tostring(uid) + "/" + fileName)
}
Persistence.readFromStorage = function (fileName) {
    // if __DEBUG then
    //     return self:readFromStorageDebug(fileName)
    // else
    // WARN: maybe multi result
    return Persistence.readFromStorageRelease(fileName)
}
Persistence.readFromStorageRelease = function (fileName) {
    assert(fileName, "fileName should not be nil")
    if (fileName) {
        var filePath = fullPathOfLocalData + "/" + fileName
        let data = cc.UserDefault.getInstance().getStringForKey(filePath)
        if(data !== ""){
            try {
                let parse_data = JSON.parse(data)
                if (type(parse_data) === "number") {
                    return parse_data
                }else{
                    return $table(parse_data)
                }
            } catch (error) {
                error.message = data
                logCenter.error(error, 'PersistenceParseError')
                return null
            }
        }else{
            return null
        }
    }
    return null
}
Persistence.readFromStorageDebug = function (fileName) {
    assert(fileName, "fileName should not be nil")
    if (fileName) {
        var filePath = fullPathOfLocalData + "/" + fileName
        var file = io.open(filePath, "rb")
        if (file) {
            var data = file.read("*a")
            file.close()
            if (data) {
                // WARN: maybe multi result
                return table.deserialize(data)
            }
        }
    }
    return null
}
Persistence.safeWriteStringToFile = function (data, filePath) {
    // var tmpName = filePath + "." + os.time()
    // var pathArr = string.split(filePath, "/")
    // table.remove(pathArr, $len(pathArr))
    // var dirPath = table.concat(pathArr, "/")
    // if (__IOS || __ANDROID) {
    //     dirPath = "/" + dirPath
    // }
    // cc.log(dirPath)
    // he.HeFileUtils.mkdirIfNotExists(dirPath)
    // var file = io.open(tmpName, "wb")
    // assert(file, "persistent file failure " + tmpName)
    // if (!file) {
    //     return 
    // }
    // var success = file.write(data)
    // if (success) {
    //     file.flush()
    //     file.close()
    //     os.remove(filePath)
    //     os.rename(tmpName, filePath)
    // } else {
    //     file.close()
    //     os.remove(tmpName)
    // }
    cc.UserDefault.getInstance().setStringForKey(filePath, data)
}
